module.exports = __webpack_public_path__ + "img/production.2f0fd014.png";